import { Box } from "@mui/material";
import { Handle, Position } from "@xyflow/react";

import type { RuleNodeProps, StopRuleNode } from "../types/nodes";

type StopNodeProps = RuleNodeProps<StopRuleNode>;

const StopNode = ({ selected }: StopNodeProps) => {
	return (
		<>
			<Box
				sx={{
					width: 32,
					height: 32,
					borderRadius: 1.5,
					border: `2px solid ${selected ? "#BF360C" : "#DD2C00"}`,
					backgroundColor: "rgba(221, 44, 0, 0.2)",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					boxShadow: selected ? 4 : 1,
					transition: "0.15s ease-in-out",
				}}
				role="img"
				aria-label={selected ? "Selected stop node" : "Stop node"}
				data-selected={selected ? "true" : "false"}
			>
				<Box
					sx={{
						width: 12,
						height: 12,
						borderRadius: "50%",
						backgroundColor: "#DD2C00",
					}}
				/>
			</Box>
			<Handle type="target" position={Position.Top} id="in" />
		</>
	);
};

export default StopNode;
